import type { UserRole } from '@dfq/shared/types/auth';

/**
 * Every staff role the platform issues (`platform/app/Enums/UserRole.php`,
 * minus `customer`). All of them currently hold admin permissions
 * (PL-AUTH-120), so console gates admit the whole list.
 */
export const STAFF_ROLES: readonly UserRole[] = ['superuser', 'admin', 'manager', 'csr', 'prepress', 'fulfillment'];
